import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
  totalAmount: 0,
};

const MAX_QUANTITY = 20;

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    // addToCart(state, action) {
    //   const product = action.payload;
    //   const existingItem = state.items.find(
    //     (item) => item.productID === product.productID
    //   );
    //   if (existingItem) {
    //     if (existingItem.quantity < MAX_QUANTITY) {
    //       existingItem.quantity += 1;
    //       state.totalAmount += product.productPrice;
    //     }
    //   } else {
    //     state.items.push({ ...product, quantity: product.quantity || 1 });
    //     state.totalAmount += product.productPrice;
    //   }
    // },
    addToCart(state, action) {
      const product = action.payload;
      // const existingItem = state.items.find(
      //   (item) => item.productID === product.productID
      // );
      const existingItem = state.items.find(
        (item) =>
          item.productID === product.productID &&
          (item.size === product.size || !product.size) &&
          (item.color === product.color || !product.color)
      );
      if (existingItem) {
        if (existingItem.quantity < MAX_QUANTITY) {
          const newQuantity = Math.min(existingItem.quantity + product.quantity, MAX_QUANTITY);
          const difference = newQuantity - existingItem.quantity;
          existingItem.quantity = newQuantity;
          state.totalAmount += difference * product.productPrice;
        }
      } else {
        const validQuantity = Math.min(product.quantity || 1, MAX_QUANTITY);
        state.items.push({ ...product, quantity: validQuantity });
        state.totalAmount += product.productPrice * validQuantity;
      }
    },
    updateQuantity(state, action) {
      const { productID,size, color, quantity } = action.payload;
      const itemToUpdate = state.items.find(
        (item) =>
          item.productID === productID &&
          (item.size === size || !size) &&
          (item.color === color || !color)
      );
      if (itemToUpdate) {
        const difference = quantity - itemToUpdate.quantity;
        if (quantity <= MAX_QUANTITY) {
          itemToUpdate.quantity = quantity;
          state.totalAmount += difference * itemToUpdate.productPrice;
        } else {
          itemToUpdate.quantity = MAX_QUANTITY;
          state.totalAmount +=
            (MAX_QUANTITY - itemToUpdate.quantity) * itemToUpdate.productPrice;
        }
      }
    },
    // updateQuantity(state, action) {
    //   const { productID, size, color, quantity } = action.payload;
    
    //   const itemToUpdate = state.items.find(
    //     (item) =>
    //       item.productID === productID &&
    //       (item.size === size || !size) &&
    //       (item.color === color || !color)
    //   );
    
    //   if (itemToUpdate) {
    //     itemToUpdate.quantity = quantity;
    //     state.totalAmount = state.items.reduce(
    //       (total, item) => total + item.quantity * item.productPrice,
    //       0
    //     );
    //   }
    // },
    // removeFromCart(state, action) {
    //   const productId = action.payload;
    //   const itemToRemove = state.items.find(
    //     (item) => item.productID === productId
    //   );
    //   if (itemToRemove) {
    //     state.totalAmount -= itemToRemove.productPrice * itemToRemove.quantity;
    //     state.items = state.items.filter(
    //       (item) => item.productID !== productId
    //     );
    //   }
    // },
    removeFromCart(state, action) {
      const { productID, size, color } = action.payload;
    
      // Find the exact product variation in the cart
      const itemToRemove = state.items.find(
        (item) =>
          item.productID === productID &&
          (item.size === size || !size) &&
          (item.color === color || !color)
      );
    
      if (itemToRemove) {
        // Deduct the total amount
        state.totalAmount -= itemToRemove.productPrice * itemToRemove.quantity;
    
        // Remove only the specific product variation
        state.items = state.items.filter(
          (item) =>
            !(
              item.productID === productID &&
              (item.size === size || !size) &&
              (item.color === color || !color)
            )
        );
      }
    },
    clearCart(state) {
      state.items = [];
      state.totalAmount = 0;
    },
  },
});

export const { addToCart, removeFromCart, updateQuantity ,clearCart } = cartSlice.actions;

export const selectCartItems = (state) => state.cart.items;
export const selectCartTotalAmount = (state) => state.cart.totalAmount;

export default cartSlice.reducer;
